import { ProfessionalTeam } from '@/data/models/ot_nationals/professional_team';
import { OvertimeEntity } from '@models/ot_nationals';
import { OtnTeam } from '@models/ot_nationals/otn_team';

export interface OtnPlayer extends OvertimeEntity {
	is_current: boolean;
	is_featured: boolean;
	family_name?: string;
	first_name?: string;
	full_name?: string;
	position?: string;
	jersey_number?: string;
	height?: number;
	weight?: number;
	image_path?: string;
	otn_team_id?: string;
	graduation_year?: number;
	tiktok_url?: string;
	twitter_url?: string;
	instagram_url?: string;
	youtube_url?: string;
	professional_team_id?: string;

	// Relationships
	otn_team?: OtnTeam;
	professional_team?: ProfessionalTeam;
}

export enum StudentClass {
	Freshman = 'Freshman',
	Sophomore = 'Sophomore',
	Junior = 'Junior',
	Senior = 'Senior',
	Graduate = 'Graduate',
}
